import { VIEWPORT_H, VIEWPORT_W } from '../constants';
import { hudLayoutScale, hudViewport } from '../hud-viewport';

const FORGE_WINDOW = { w: 1095, h: 335, y: 350 };
const INVENTORY_WINDOW = { w: 808, h: 815 };
const INVENTORY_CRAFTING_Y = 792;

export const FORGE_UI = {
  window: {
    x: (VIEWPORT_W - FORGE_WINDOW.w) / 2,
    y: FORGE_WINDOW.y,
    w: FORGE_WINDOW.w,
    h: FORGE_WINDOW.h,
  },
  slotSize: 244,
  slots: {
    1: { x: 45, y: 45 },
    2: { x: 301, y: 45 },
    result: { x: 805, y: 45 },
  },
  forgeBtn: { x: 583, y: 130, w: 184, h: 74 },
  dustCost: { x: 583, y: 210 },
};

export const INVENTORY_UI = {
  window: {
    x: (VIEWPORT_W - INVENTORY_WINDOW.w) / 2,
    y: (VIEWPORT_H - INVENTORY_WINDOW.h) / 2,
    w: INVENTORY_WINDOW.w,
    h: INVENTORY_WINDOW.h,
  },
  craftingWindow: {
    x: (VIEWPORT_W - INVENTORY_WINDOW.w) / 2,
    y: INVENTORY_CRAFTING_Y,
    w: INVENTORY_WINDOW.w,
    h: INVENTORY_WINDOW.h,
  },
  gridInset: 38,
  gridGap: 18,
  columns: 3,
  visibleRows: 3,
  slotAspect: 245 / 244,
};

export type WinRect = { x: number; y: number; w: number; h: number };

/** Inventory window centered in the visible HUD region (not the full design canvas). */
export function inventoryWindowRect(): WinRect {
  const scale = hudLayoutScale();
  const w = Math.round(INVENTORY_WINDOW.w * scale);
  const h = Math.round(INVENTORY_WINDOW.h * scale);
  return {
    x: (hudViewport.width - w) / 2,
    y: (hudViewport.height - h) / 2,
    w,
    h,
  };
}

/** Inventory under the forge during crafting — still horizontally centered on the HUD. */
export function inventoryCraftingWindowRect(): WinRect {
  const scale = hudLayoutScale();
  const w = Math.round(INVENTORY_WINDOW.w * scale);
  const h = Math.round(INVENTORY_WINDOW.h * scale);
  return {
    x: (hudViewport.width - w) / 2,
    y: Math.round(INVENTORY_CRAFTING_Y * scale),
    w,
    h,
  };
}

export function forgeWindowRect(): WinRect {
  const scale = hudLayoutScale();
  const w = Math.round(FORGE_WINDOW.w * scale);
  const h = Math.round(FORGE_WINDOW.h * scale);
  return {
    x: (hudViewport.width - w) / 2,
    y: Math.round(FORGE_WINDOW.y * scale),
    w,
    h,
  };
}

export function inventoryGridMetrics(win = INVENTORY_UI.window) {
  const { gridInset, gridGap, columns, visibleRows } = INVENTORY_UI;
  const inset = Math.round(gridInset * (win.w / INVENTORY_WINDOW.w));
  const gap = Math.round(gridGap * (win.w / INVENTORY_WINDOW.w));
  const innerW = win.w - inset * 2;
  const cellW = (innerW - gap * (columns - 1)) / columns;
  const cellH = cellW * INVENTORY_UI.slotAspect;
  const viewportH = visibleRows * cellH + (visibleRows - 1) * gap;
  return { cellW, cellH, gap, columns, visibleRows, viewportH, gridInset: inset };
}
